import { CSS, StyleProps } from "@shared/primitive-components"

export const chevronLinkStyle = (props: StyleProps): CSS => ({
  color: props.theme.palette.coal.dark,

  "& > svg": {
    width: `24px`,
    height: `24px`,
  },
})

export const blur = (): CSS => ({
  color: `transparent`,
  textShadow: `1px 1px 8px black`,
})
